import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var PayoutNotReceivedIA = function PayoutNotReceivedIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Vlx7bU",
    defaultMessage: [{
      "type": 0,
      "value": "Als je vertraging ondervindt bij het ontvangen van je uitbetaling, is het essentieel dat je enkele belangrijke gegevens over je bestelling en accountinstellingen controleert om te begrijpen waarom je uitbetaling vertraagd is. Dit is wat je moet controleren:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "L8yZ/q",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Bestellingsstatus:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " je bestelling moet zijn gemarkeerd als ‘Verzonden’ om een uitbetaling te activeren. Zorg ervoor dat je de trackinggegevens van de zending hebt ingevoerd, zodat de status correct is."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bNsRBC",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Uitbetalingsopties:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " controleer de "
    }, {
      "children": [{
        "type": 0,
        "value": "uitbetalingsvoorwaarden"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " die je hebt geselecteerd. De betaling wordt maximaal 60 dagen na verzending verwerkt, afhankelijk van de voorwaarden die je kiest. Het duurt meestal 3 tot 5 werkdagen voordat het op je rekening staat, afhankelijk van de verwerkingstijd van je bank."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "KumpfT",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Bankrekeninggegevens:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " controleer nogmaals of je bankrekeninggegevens correct en actueel zijn. Onjuiste gegevens kunnen leiden tot vertragingen bij de uitbetaling."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hLc85/",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Voorbestellingen:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " voor voorbestellingen kunnen zowel de uitbetalings- als de verzenddatum als ‘Onbekend’ worden weergegeven totdat de voorbestelling is verwerkt. Je kan pas een uitbetaling verwachten wanneer deze bestellingen zijn verwerkt."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};